module.exports = __webpack_public_path__ + "static/media/leaf.31d0ab66.svg";